import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import ProTip from './ProTip';
import Card from './Card';

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Your Websi111te
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function App() {
  return (
    <Box sx={{maxWidth: 600, mx: 'auto', my: 3}}>
        <Typography sx={{mx: 2}} variant="h4" component="h1" gutterBottom>
            Help fund Ukrainian based filmmakers to document current events in their country!
        </Typography>
        <ProTip />
        <Card />
        {/* <Copyright /> */}
    </Box>
  );
}
